export default __webpack_public_path__ + "static/media/location-intelligence-logo-white.850f3ffb.svg";